export class PracticeConfig {
  practiceId?: number;
  keyName: string;
  keyValue: string;
  configType: number;
}

export class CreatePracticeConfigCommand {
  practiceConfigList: PracticeConfig[];
  isOnlyKeySave?: boolean = false;
}

export class PracticeScheduleConfig {
  id?: number;
  practiceId: number;
  cronExpression: string;
  dataContexts: number[];
  hasUpdated: boolean | null;
  lastExecution: string | null;
  lastExecutionNote: string | null;
  lastExecutionStatus: number | null;
  scheduleEndTime: string;
  scheduleTime: string;
  timeFrequency: number;
  jobName: string | null;
  isActive: boolean;
}

export class CreatePracticeScheduleJobCommand {
  id?: number;
  practiceId: number;
  dataContextIds: number[];
  scheduleEndTime?: string;
  scheduleTime?: string | any;
  timeFrequency: number;
  jobName?: string;
  isOnDemand?: boolean;
  dataContextGroup?: any;
  isActive?: boolean;
  loadType?: number;
  timeZone?: string;
  frequencyType?: number;
  frequencyBy?: number;
  weekDays?: string;
  scheduleStartDate?: any; 

  seconds?: string;
  minutes?: string;
  hours?: string;
  dayOfMonth?: string;
  months?: string;
  dayOfWeek?: string;
  year?: string;
  isDefaultSchedule?: boolean;
}

export class UpdatePracticeScheduleJobCommand {
  id: number;
  jobName: string;
  practiceId: number;
  dataContextIds: number[];
  scheduleEndTime: string;
  scheduleTime: string;
  timeFrequency: number;
  isActive: boolean;
}

export class AllScheduleConfigListReq {
  searchTerm: string = '';
  sortBy: number = 1;
  sortFieldName: string = '';
  pageNumber: number = 1;
  pageSize: number = 15;
  practiceId: number = 0;
}

export class FrequencyInMinutes {
  name: string;
  value: string;
}

export class CreteCronCommand {
  scheduleEndTime?: string | any;
  scheduleTime?: string | any;
  loadType?: number;
  frequencyType?: number;
  frequencyBy?: number;
  timeFrequency: number;
  weekDays?: string;
}
export class PmsConfigResponse{
  odBaseUrl?:string;
}